export const EditMixin = {
  mixins: [],
  data() {
    return {}
  },
  created() {},
  methods: {
    //验证整数，validator:checkInt
    checkInt(rule, val, callback) {
      if (val) {
        if (isNaN(val)) {
          callback('仅整数！')
        }
      }
      callback()
    },
    //验证数字
    checkNumber(rule, val, callback) {
      if (val || val == '0') {
        if (isNaN(val)) {
          callback('仅数字！')
        } else if (parseFloat(val) < 0) {
          callback('仅正数！')
        } else if (
          parseFloat(val) != 0 &&
          !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(val)
        ) {
          callback('小数后仅2位！')
        }
      }
      callback()
    },
    //验证年龄
    checkAge(rule, val, callback) {
      if (val || val == '0') {
        if (isNaN(val)) {
          callback('仅整数！')
        }
        if (parseInt(val) < 1 || parseInt(val) > 110) {
          callback('请输入正确的年龄')
        }
      }
      callback()
    },
    //验证手机
    checkPhone(rule, val, callback) {
      if (val) {
        if (!/^1[3456789]\d{9}$/.test(val)) {
          callback('手机号码有误！')
        }
      }
      callback()
    },
    //验证身份证号
    checkIdNo(rule, val, callback) {
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
      if (val) {
        if (!_IDRe18.test(val) && !_IDre15.test(val)) {
          callback('身份证号码有误！')
        }
      }
      callback()
    },

    /**
     * 解析身份证
     * @param UUserCard
     * @param num 1 出生日期 2性别 3年龄
     * @returns {*}
     */
    parseIdCard(UUserCard, num) {
      if (UUserCard) {
        if (num === 1) {
          const value = UUserCard.substr(6, 8)
          const year = value.substr(0, 4)
          const month = value.substr(4, 2)
          const day = value.substr(6, 2)
          //获取出生日期
          return year + '-' + month + '-' + day
        }
        if (num === 2) {
          //获取性别
          if (parseInt(UUserCard.substr(16, 1)) % 2 === 1) {
            //男
            return '男'
          } else {
            //女
            return '女'
          }
        }
        if (num === 3) {
          return this.getAge(UUserCard)
        }
      }
    },
    /**
     * 根据身份证获取年龄
     * @param identityCard
     * @returns {number}
     */
    getAge(identityCard) {
      var age = 0
      try {
        var len = (identityCard + '').length
        if (len == 0) {
          return 0
        } else {
          if (len != 15 && len != 18) {
            //身份证号码只能为15位或18位其它不合法
            return 0
          }
        }
        var strBirthday = ''
        if (len == 18) {
          //处理18位的身份证号码从号码中得到生日和性别代码
          strBirthday =
            identityCard.substr(6, 4) +
            '/' +
            identityCard.substr(10, 2) +
            '/' +
            identityCard.substr(12, 2)
        }
        if (len == 15) {
          strBirthday =
            '19' +
            identityCard.substr(6, 2) +
            '/' +
            identityCard.substr(8, 2) +
            '/' +
            identityCard.substr(10, 2)
        }
        //时间字符串里，必须是“/”
        var birthDate = new Date(strBirthday)
        var nowDateTime = new Date()
        if (nowDateTime.getFullYear() >= birthDate.getFullYear()) {
          age = nowDateTime.getFullYear() - birthDate.getFullYear()
          //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
          if (
            nowDateTime.getMonth() < birthDate.getMonth() ||
            (nowDateTime.getMonth() == birthDate.getMonth() &&
              nowDateTime.getDate() < birthDate.getDate())
          ) {
            age--
          }
        }
      } catch (e) {
        age = 0
      }
      //console.log('age = ' + age);
      return age
    },

    //获取文本中字母和数字的数量
    getCharNumCount(text) {
      let chars = text.replace(/[^a-zA-Z]/g, '')
      let nums = /(\d+(\.\d+)?)/.exec(text)

      if (nums && nums.length > 0) {
        nums = nums[0]
      }
      nums = nums ? nums : ''
      //   console.log({ charCount: chars.length, numCount: nums.length })
      return chars.length + nums.length
    },
  },
}
